import api from "api/config";

export const CreateRequestAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/requests/create-request",
    data,
  });

  return response;
};

export const GetRequestsAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/requests/list",
    data,
  });

  return response;
};

export const GetRequestsByStayAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/requests/list-by-stay",
    data,
  });

  return response;
};

export const GetRequestDetailsAPI = async (requestId) => {
  const response = await api({
    method: "GET",
    url: `/api/v1/requests/${requestId}`,
  });

  return response;
};

export const UpdateRequestAPI = async ({ requestId, data }) => {
  const response = await api({
    method: "PUT",
    url: `/api/v1/requests/${requestId}`,
    data,
  });

  return response;
};

export const BulkCompleteRequestsAPI = async (data) => {
  const response = await api({
    method: "PATCH",
    url: "/api/v1/requests/bulk-complete",
    data,
  });

  return response;
};

export const SoftDeleteRequestAPI = async (requestId) => {
  const response = await api({
    method: "DELETE",
    url: `/api/v1/requests/${requestId}?confirm=true`,
  });

  return response;
};
